
import React, { useEffect, useState } from "react";
import { Button, ClickAwayListener, IconButton } from "@material-ui/core";
import BadgeNotification from "../Notification/BadgeNotification";
import useStyles from "../../assets/styles/styles";
import NotificationsIcon from '@material-ui/icons/Notifications';
import CardNotification from "./CardNotification";
import { useHistory } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import {BroadcastChannel} from 'broadcast-channel';
import { Typography } from "@mui/material";
import CardCommunication from "./CardCommunication";
import { setCount, getAllCommunications, removeModifyCommunication, setCommunication } from "../../redux/actions/communicatedAction";
import BadgeCommunication from "../Communication/BadgeCommunication";

const DropdownCommunication = () => {

    const dispatch = useDispatch();
    const classes = useStyles();
    const communicatedReducer =useSelector((state) => state.communicatedReducer.communication);
    const [openCommunication, setOpenCommunication] = useState(false);
    const allCommunicationsViewed = communicatedReducer?.communication?.every(communication => communication.viewed === true);

    const counterNotification = useSelector(state => state.communicatedReducer.countCommunication);
    const modifyNotificationsReducer = useSelector(state => state.communicatedReducer.modifyCommunications);
    const history = useHistory();

    const handleClickAway = () => {
        setOpenCommunication(false);
    };

    const handleClick = () => {
        dispatch(setCommunication(0));
        setOpenCommunication((prev) => !prev);
    };

    const channel = new BroadcastChannel('displayed-messages');
    channel.onmessage= function(event){
        setTimeout(function(){        
             dispatch(getAllCommunications({email: window.localStorage.getItem('email')}));
         }, 3000);
    }


    useEffect(() => {
        const today = new Date();
        const notReview = communicatedReducer?.communication?.filter(item => {
        const initialDate = new Date(item.initialDate);
        const finalDate = new Date(item.finalDate);

            return !item.viewed && today >= initialDate && today <= finalDate;
        });
        if (notReview) {
            dispatch(setCount(notReview.length))
        }
    }, [communicatedReducer?.communication])

    useEffect(()=>{
        if(modifyNotificationsReducer){
            dispatch(removeModifyCommunication(false));
            dispatch(getAllCommunications({email: window.localStorage.getItem('email')}));
        }
    },[modifyNotificationsReducer])

    return (
        <ClickAwayListener mouseEvent="onMouseDown" touchEvent="onTouchStart" onClickAway={handleClickAway}>
            <div style={{ position: "relative" }}>
                {counterNotification > 0 ?
                    <BadgeCommunication
                        childrenItem={
                            <IconButton
                                style={{ padding: '0px' }}
                                edge="start"
                                className={classes.menuButtonRight}
                                color="inherit"
                                onClick={handleClick}
                            >
                                <NotificationsIcon />
                            </IconButton>}
                        countCommunication={counterNotification}
                    />
                    :
                    <IconButton
                        style={{ padding: '0px' }}
                        edge="start"
                        className={classes.menuButtonRight}
                        color="inherit"
                        onClick={handleClick}
                    >
                        <NotificationsIcon />
                    </IconButton>
                }
                {openCommunication ? (
                    <div className={classes.dropdownNotification} style={{ width: '330px' }}>

                        <div className={classes.heightDivRegisters}>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <Button
                                    onClick={() => { history.push('/AllCommunications') }}
                                    className={`${classes.buttomAllCommunication} ${classes.lightLinearGradient}`}>
                                    Ver todas
                                </Button>
                                {
                                    allCommunicationsViewed &&
                                    <Typography className={`${classes.txtSubtitle}`} style={{ fontSize: '11px', fontWeight: 'bold' }}>
                                        No hay notificaciones sin leer
                                    </Typography>
                                }
                            </div>
                            { communicatedReducer?.communication?.filter(item => {
                                const today = new Date();
                                const initialDate = new Date(item.initialDate);
                                const finalDate = new Date(item.finalDate);
                                    return item.viewed === false && initialDate <= today && finalDate >= today;
                            })
                            .map((item, i) => (
                                    <CardCommunication key={i}  communication={item} position={i} />
                            ))}
                        </div>

                    </div>)
                    : ""}
            </div>
        </ClickAwayListener>);


};

export default DropdownCommunication;


